var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgMapTitle = function SvgMapTitle(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 144 22",
    style: {
      enableBackground: "new 0 0 144 22"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "location_1_",
    transform: "translate(0.000000, 2914.000000)",
    d: "M1.3-2912.9h5.1v15.1h9v4.8H1.3V-2912.9z M36.2-2902.9 c0,5.7-4.7,10.4-10.4,10.4s-10.4-4.7-10.4-10.4s4.7-10.4,10.4-10.4S36.2-2908.7,36.2-2902.9z M30.8-2902.9c0-2.9-2.2-5.3-4.9-5.3 s-4.9,2.4-4.9,5.3c0,2.9,2.2,5.3,4.9,5.3S30.8-2900,30.8-2902.9z M52.6-2906.5c-0.9-1-2.5-1.7-4.2-1.7c-2.7,0-4.9,2.4-4.9,5.3 c0,2.9,2.1,5.3,5.1,5.3c1.5,0,3-0.7,3.9-1.7l3.4,3.8c-1.7,2-4.2,3.1-7.7,3.1c-5.9,0-10.3-4.7-10.3-10.4s4.6-10.4,10.3-10.4 c3.6,0,6,1.2,7.6,2.9L52.6-2906.5z M71-2896.8h-7.8l-1.4,3.8h-5.4l7.8-19.9h6L78-2893h-5.6L71-2896.8z M67.1-2907.4l-2.3,6.2h4.5 L67.1-2907.4z M86.7-2908.1v15.1h-5.1v-15.1h-5.4v-4.8h16v4.8H86.7z M94.3-2912.9h5.1v19.9h-5.1V-2912.9z M123-2902.9 c0,5.7-4.7,10.4-10.4,10.4s-10.4-4.7-10.4-10.4s4.7-10.4,10.4-10.4S123-2908.7,123-2902.9z M117.6-2902.9c0-2.9-2.2-5.3-4.9-5.3 s-4.9,2.4-4.9,5.3c0,2.9,2.2,5.3,4.9,5.3S117.6-2900,117.6-2902.9z M131-2904.3v11.3h-5.1v-19.9h5.5l7.3,11.5v-11.5h5.1v19.9h-5.5 L131-2904.3z"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgMapTitle, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/map_title.384896cf.svg";
export { ForwardRef as ReactComponent };